import React from 'react';
import { useTranslation } from 'react-i18next';
import type { InvoiceUnifiedStatus } from '@hero/api';
import { Badge } from '../../../ui/Badge/Badge';
import { getInvoiceStatusBadgeClass } from '@hero/web-theme';
import { InvoiceStatusDynamicIcon } from '@hero/web-icons';

export interface InvoiceStatusBadgeProps {
  /** Invoice status (supports both InvoiceStatus and InvoiceUnifiedStatus) */
  status: InvoiceUnifiedStatus;
  /** Whether to show the status icon (defaults to true) */
  showIcon?: boolean;
  /** Optional content appended after the status label inside the badge (e.g. Price component) */
  suffix?: React.ReactNode;
}

export function InvoiceStatusBadge({ status, showIcon = true, suffix }: InvoiceStatusBadgeProps) {
  const { t } = useTranslation('m-payment');

  const style = getInvoiceStatusBadgeClass(status);
  const label = t(`invoice.status.${status}`);

  return (
    <Badge
      variant="secondary"
      size="small"
      className={style}
      icon={showIcon ? <InvoiceStatusDynamicIcon status={status} /> : undefined}>
      {label}
      {suffix && <span className="opacity-70">{suffix}</span>}
    </Badge>
  );
}
